/**
 * Project-wide: treat these as "no value" so we hide the field instead of showing N/A/—.
 */
const PLACEHOLDER_REGEX = /^(n\/a|na|—|–|-|--|null|undefined|soon|not available|tbd|to be determined|tba|price on request|price on call)$/i;

export function isPlaceholder(value) {
  if (value == null) return true;
  const str = String(value).trim();
  if (str.length === 0) return true;
  return PLACEHOLDER_REGEX.test(str);
}

/** Use this before rendering optional fields: when true, show the value; when false, hide the field. */
export function shouldDisplay(value) {
  return !isPlaceholder(value);
}

/** Alias for shouldDisplay – use when you only render when there is real data. */
export function hasRealValue(value) {
  return shouldDisplay(value);
}
